import { ExtLink } from '../../../components/controls';

export const AccountServicesHelp = {
  services: {
    aws: {
      label: 'Amazon AWS S3',
      text: (
        <>
          Before creating any products in Pulse, you’ll need to connect your
          Amazon S3 account to the system. You can do this by setting up a new
          S3 user in Amazon’s &quot;IAM&quot; (Identity and Access Management)
          system with just “read access” only. This may sound complex, but it’s
          actually very simple - just follow these steps
        </>
      ),
      url: 'https://www.notion.so/pulseapp/Connecting-Your-S3-Account-to-Pulse-d9c759bb8cd84c499501a8e7311ebc35',
    },
    shopify: {
      label: 'Shopify',
      text: (
        <>
          To integrate Pulse with Shopify, you&apos;ll need to do a few steps
          from the instruction.
        </>
      ),
      url: 'https://www.notion.so/pulseapp/Integrating-Pulse-with-Shopify-ba0a39d0ae5e4f99aa624b576d1b1679',
    },
    storage: {
      label: 'Storage service',
      text: (
        <>
          Before creating product a storage service should be configured.
          Currently,
          <ExtLink href="https://aws.amazon.com/s3/">Amazon AWS S3</ExtLink>
          is supported.
        </>
      ),
    },
    squarespace: {
      label: 'Squarespace',
      text: (
        <>
          To integrate Pulse with Squarespace, you&apos;ll need to allow Pulse
          view your order information
        </>
      ),
      url: 'https://www.notion.so/pulseapp/Integrating-Pulse-with-Squarespace-e9b85b5024a84f0ebab1d14d52355c34',
    },
    webhook: {
      label: 'E-commerce integration',
      text: (
        <>
          Pulse is compatible with most major eCommerce platforms. Please find
          the exact integration steps for your own platform.
        </>
      ),
    },
    wix: {
      label: 'Wix',
      text: (
        <>
          To integrate Pulse with Wix, you&apos;ll need to ask us for
          PROVIDER-ID and API-KEY keys and then setup integration on your site.
        </>
      ),
      url: 'https://www.notion.so/pulseapp/Integrating-Pulse-with-Wix-81f78a67b7d847ce8874dcad22e8245b',
    },
  },

  emailTemplate: {
    label: 'Email template customization',
    text: (
      <>
        If you use the Shopify, Wix or Squarespace integrations with Pulse,
        Pulse will automatically send the customer an email after purchase which
        contains their redemption key information. You can use{' '}
        <i>[products-names]</i> and <i>[redemption-keys]</i> tags which will be
        replaced by the actual values.
      </>
    ),
    url: 'https://www.notion.so/pulseapp/How-to-Customise-Your-Pulse-Email-Template-Wix-Shopify-Squarespace-Only-b176bfd39a014206b1b0821133f465c6',
  },
};
